import { useNavigate } from 'react-router-dom';
import { trpc } from '../utils/trpc.ts';
import '../styles/VenueOwnerProfile.css';
import ProfilePictureUpload from '../components/ProfilePictureUpload';
import VenueCard from './VenueCard';
import { useEffect } from 'react';
import { useBannerStore } from '../utils/banner.ts';
import VenueNotificationSender from '../components/VenueNotificationSender.tsx';

const VenueOwnerProfile = () => {
  const navigate = useNavigate();

  const showBanner = useBannerStore((state) => state.showBanner);
  const clearBanner = useBannerStore((state) => state.clearBanner);

  // Fetch owner's personal profile (with refetch for after upload)
  const {
    data: profile,
    isLoading: profileLoading,
    refetch: refetchProfile,
  } = trpc.venueOwner.getMyProfile.useQuery();

  useEffect(() => {
    if(!profile) return;
    showBanner({
      icon: profile.profile_picture_url,
      header: 'YOUR ACCOUNT',
      buttons: {
        View: '/venue-owner/profile',
        Edit: '/venue-owner/edit',
        Settings: '/venue-owner/settings/settings',
      },
      selected: 'View',
    });
    return () => clearBanner();
  }, [profile]);

  const updateProfile = trpc.venueOwner.updateMyProfile.useMutation({
    onSuccess: () => refetchProfile(),
  });

  const { data: venues, isLoading: venuesLoading } = trpc.venue.getMyVenues.useQuery();

  if (profileLoading || venuesLoading) {
    return (
      <div className="profile-loading">
        <p>Loading profile...</p>
      </div>
    );
  }

  if (!profile) {
    navigate('/dashboard');
    return null;
  }

  return (
    <div className="venue-owner-profile-container">
      {/* Profile Header */}
      <div className="profile-header-card">
        <div className="profile-pic-container">
          <ProfilePictureUpload
            currentUrl={profile.profile_picture_url || null}
            userId={profile.id}
            onUploadComplete={(url) => {
              updateProfile.mutate({ profile_picture_url: url });
            }}
            size={140}
            fallbackLetter={profile.username?.charAt(0) || '?'}
          />
        </div>
        <div className="owner-identity">
          <h1 id="owner-username">@{profile.username}</h1>
          <p className="owner-type-badge">Venue Owner</p>
        </div>
        <div className="profile-actions">
          <button
            className="edit-profile-btn"
            onClick={() => navigate('/venue-owner/edit')}
          >
            Edit Profile
          </button>
        </div>
      </div>

      {/* Venues Section */}
      <div className="venues-section">
        <div className="section-header-row">
          <h2 className="section-title">My Venues</h2>
          <button className="add-venue-btn" onClick={() => navigate('/venues/create')}>
            + Add New Venue
          </button>
        </div>

        {venues && venues.length > 0 ? (
          <div className="venues-container">
            {venues.map((venue) => (
              <VenueCard venue={venue} />
            ))}
          </div>
        ) : (
          <div className="empty-venues">
            <p>You haven't added any venues yet.</p>
            <button
              className="create-venue-link"
              onClick={() => navigate('/venues/create')}
            >
              Create your first venue
            </button>
          </div>
        )}
      </div>
      <VenueNotificationSender></VenueNotificationSender>
    </div>
  );
};

export default VenueOwnerProfile;
